export const getErrorMessage = error => {
	if (error.response && error.response.data !== undefined) {
		return error.response.data.message;
	} else if (error.message) {
		return error.message;
	} else {
		return error;
	}
}